"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.key = exports.piqure = exports.piqureWrapper = void 0;
const Value_1 = require("./Value");
const piqureWrapper = (wrapper, field) => {
    const wrapperTyped = wrapper;
    wrapperTyped[field] = wrapperTyped[field] ?? new Map();
    return (0, exports.piqure)(wrapperTyped[field]);
};
exports.piqureWrapper = piqureWrapper;
const piqure = (memory = new Map()) => {
    const provide = (key, injected) => {
        memory.set(key, new Value_1.StaticValue(injected));
    };
    const provideLazy = (key, provider) => {
        memory.set(key, new Value_1.LazyValue(provider));
    };
    return {
        provide,
        provideLazy,
        inject(key) {
            if (!memory.has(key)) {
                throw new Error(`The key ${key.toString()} is not provided`);
            }
            return memory.get(key)?.get();
        },
        provides(list) {
            list.forEach(([key, value]) => provide(key, value));
        },
    };
};
exports.piqure = piqure;
const key = (description) => Symbol(description);
exports.key = key;
//# sourceMappingURL=Piqure.js.map